export const COUNTRIES = [
    {
      name: "Afghanistan",
      dial_code: "+93",
      flag: "🇦🇫",
      code: "AF",
      timezone: "Asia/Kabul",
    },
    {
      name: "Aland Islands",
      dial_code: "+358",
      flag: "🇦🇽",
      code: "AX",
      timezone: "Europe/Mariehamn",
    },
    {
      name: "Albania",
      dial_code: "+355",
      flag: "🇦🇱",
      code: "AL",
      timezone: "Europe/Tirane",
    },
    {
      name: "Algeria",
      dial_code: "+213",
      flag: "🇩🇿",
      code: "DZ",
      timezone: "Africa/Algiers",
    },
    {
      name: "AmericanSamoa",
      dial_code: "+1684",
      flag: "🇦🇸",
      code: "AS",
      timezone: "Pacific/Pago_Pago",
    },
    {
      name: "Andorra",
      dial_code: "+376",
      flag: "🇦🇩",
      code: "AD",
      timezone: "Europe/Andorra",
    },
    {
      name: "Angola",
      dial_code: "+244",
      flag: "🇦🇴",
      code: "AO",
      timezone: "Africa/Luanda",
    },
    {
      name: "Anguilla",
      dial_code: "+1264",
      flag: "🇦🇮",
      code: "AI",
      timezone: "America/Anguilla",
    },
    {
      name: "Antarctica",
      dial_code: "+672",
      flag: "🇦🇶",
      code: "AQ",
      timezone: "Antarctica/McMurdo",
    },
    {
      name: "Antigua and Barbuda",
      dial_code: "+1268",
      flag: "🇦🇬",
      code: "AG",
      timezone: "America/Antigua",
    },
    {
      name: "Argentina",
      dial_code: "+54",
      flag: "🇦🇷",
      code: "AR",
      timezone: "America/Argentina/Buenos_Aires",
    },
    {
      name: "Armenia",
      dial_code: "+374",
      flag: "🇦🇲",
      code: "AM",
      timezone: "Asia/Yerevan",
    },
    {
      name: "Aruba",
      dial_code: "+297",
      flag: "🇦🇼",
      code: "AW",
      timezone: "America/Aruba",
    },
    {
      name: "Australia",
      dial_code: "+61",
      flag: "🇦🇺",
      code: "AU",
      timezone: "Australia/Sydney",
    },
    {
      name: "Austria",
      dial_code: "+43",
      flag: "🇦🇹",
      code: "AT",
      timezone: "Europe/Vienna",
    },
    {
      name: "Azerbaijan",
      dial_code: "+994",
      flag: "🇦🇿",
      code: "AZ",
      timezone: "Asia/Baku",
    },
    {
      name: "Bahamas",
      dial_code: "+1242",
      flag: "🇧🇸",
      code: "BS",
      timezone: "America/Nassau",
    },
    {
      name: "Bahrain",
      dial_code: "+973",
      flag: "🇧🇭",
      code: "BH",
      timezone: "Asia/Bahrain",
    },
    {
      name: "Bangladesh",
      dial_code: "+880",
      flag: "🇧🇩",
      code: "BD",
      timezone: "Asia/Dhaka",
    },
    {
      name: "Barbados",
      dial_code: "+1246",
      flag: "🇧🇧",
      code: "BB",
      timezone: "America/Barbados",
    },
    {
      name: "Belarus",
      dial_code: "+375",
      flag: "🇧🇾",
      code: "BY",
      timezone: "Europe/Minsk",
    },
    {
      name: "Belgium",
      dial_code: "+32",
      flag: "🇧🇪",
      code: "BE",
      timezone: "Europe/Brussels",
    },
    {
      name: "Belize",
      dial_code: "+501",
      flag: "🇧🇿",
      code: "BZ",
      timezone: "America/Belize",
    },
    {
      name: "Benin",
      dial_code: "+229",
      flag: "🇧🇯",
      code: "BJ",
      timezone: "Africa/Porto-Novo",
    },
    {
      name: "Bermuda",
      dial_code: "+1441",
      flag: "🇧🇲",
      code: "BM",
      timezone: "Atlantic/Bermuda",
    },
    {
      name: "Bhutan",
      dial_code: "+975",
      flag: "🇧🇹",
      code: "BT",
      timezone: "Asia/Thimphu",
    },
    {
      name: "Bolivia, Plurinational State of",
      dial_code: "+591",
      flag: "🇧🇴",
      code: "BO",
      timezone: "America/La_Paz",
    },
    {
      name: "Bosnia and Herzegovina",
      dial_code: "+387",
      flag: "🇧🇦",
      code: "BA",
      timezone: "Europe/Sarajevo",
    },
    {
      name: "Botswana",
      dial_code: "+267",
      flag: "🇧🇼",
      code: "BW",
      timezone: "Africa/Gaborone",
    },
    {
      name: "Brazil",
      dial_code: "+55",
      flag: "🇧🇷",
      code: "BR",
      timezone: "America/Sao_Paulo",
    },
    {
      name: "British Indian Ocean Territory",
      dial_code: "+246",
      flag: "🇮🇴",
      code: "IO",
      timezone: "Indian/Chagos",
    },
    {
      name: "Brunei Darussalam",
      dial_code: "+673",
      flag: "🇧🇳",
      code: "BN",
      timezone: "Asia/Brunei",
    },
    {
      name: "Bulgaria",
      dial_code: "+359",
      flag: "🇧🇬",
      code: "BG",
      timezone: "Europe/Sofia",
    },
    {
      name: "Burkina Faso",
      dial_code: "+226",
      flag: "🇧🇫",
      code: "BF",
      timezone: "Africa/Ouagadougou",
    },
    {
      name: "Burundi",
      dial_code: "+257",
      flag: "🇧🇮",
      code: "BI",
      timezone: "Africa/Bujumbura",
    },
    {
      name: "Cambodia",
      dial_code: "+855",
      flag: "🇰🇭",
      code: "KH",
      timezone: "Asia/Phnom_Penh",
    },
    {
      name: "Cameroon",
      dial_code: "+237",
      flag: "🇨🇲",
      code: "CM",
      timezone: "Africa/Douala",
    },
    {
      name: "Canada",
      dial_code: "+1",
      flag: "🇨🇦",
      code: "CA",
      timezone: "America/Toronto",
    },
    {
      name: "Cape Verde",
      dial_code: "+238",
      flag: "🇨🇻",
      code: "CV",
      timezone: "Atlantic/Cape_Verde",
    },
    {
      name: "Cayman Islands",
      dial_code: "+345",
      flag: "🇰🇾",
      code: "KY",
      timezone: "America/Cayman",
    },
    {
      name: "Central African Republic",
      dial_code: "+236",
      flag: "🇨🇫",
      code: "CF",
      timezone: "Africa/Bangui",
    },
    {
      name: "Chad",
      dial_code: "+235",
      flag: "🇹🇩",
      code: "TD",
      timezone: "Africa/Ndjamena",
    },
    {
      name: "Chile",
      dial_code: "+56",
      flag: "🇨🇱",
      code: "CL",
      timezone: "America/Santiago",
    },
    {
      name: "China",
      dial_code: "+86",
      flag: "🇨🇳",
      code: "CN",
      timezone: "Asia/Shanghai",
    },
    {
      name: "Christmas Island",
      dial_code: "+61",
      flag: "🇨🇽",
      code: "CX",
      timezone: "Indian/Christmas",
    },
    {
      name: "Cocos (Keeling) Islands",
      dial_code: "+61",
      flag: "🇨🇨",
      code: "CC",
      timezone: "Indian/Cocos",
    },
    {
      name: "Colombia",
      dial_code: "+57",
      flag: "🇨🇴",
      code: "CO",
      timezone: "America/Bogota",
    },
    {
      name: "Comoros",
      dial_code: "+269",
      flag: "🇰🇲",
      code: "KM",
      timezone: "Indian/Comoro",
    },
    {
      name: "Congo",
      dial_code: "+242",
      flag: "🇨🇬",
      code: "CG",
      timezone: "Africa/Brazzaville",
    },
    {
      name: "Congo, The Democratic Republic of the Congo",
      dial_code: "+243",
      flag: "🇨🇩",
      code: "CD",
      timezone: "Africa/Kinshasa",
    },
    {
      name: "Cook Islands",
      dial_code: "+682",
      flag: "🇨🇰",
      code: "CK",
      timezone: "Pacific/Rarotonga",
    },
    {
      name: "Costa Rica",
      dial_code: "+506",
      flag: "🇨🇷",
      code: "CR",
      timezone: "America/Costa_Rica",
    },
    {
      name: "Cote d'Ivoire",
      dial_code: "+225",
      flag: "🇨🇮",
      code: "CI",
      timezone: "Africa/Abidjan",
    },
    {
      name: "Croatia",
      dial_code: "+385",
      flag: "🇭🇷",
      code: "HR",
      timezone: "Europe/Zagreb",
    },
    {
      name: "Cuba",
      dial_code: "+53",
      flag: "🇨🇺",
      code: "CU",
      timezone: "America/Havana",
    },
    {
      name: "Cyprus",
      dial_code: "+357",
      flag: "🇨🇾",
      code: "CY",
      timezone: "Asia/Nicosia",
    },
    {
      name: "Czech Republic",
      dial_code: "+420",
      flag: "🇨🇿",
      code: "CZ",
      timezone: "Europe/Prague",
    },
    {
      name: "Denmark",
      dial_code: "+45",
      flag: "🇩🇰",
      code: "DK",
      timezone: "Europe/Copenhagen",
    },
    {
      name: "Djibouti",
      dial_code: "+253",
      flag: "🇩🇯",
      code: "DJ",
      timezone: "Africa/Djibouti",
    },
    {
      name: "Dominica",
      dial_code: "+1767",
      flag: "🇩🇲",
      code: "DM",
      timezone: "America/Dominica",
    },
    {
      name: "Dominican Republic",
      dial_code: "+1849",
      flag: "🇩🇴",
      code: "DO",
      timezone: "America/Santo_Domingo",
    },
    {
      name: "Ecuador",
      dial_code: "+593",
      flag: "🇪🇨",
      code: "EC",
      timezone: "America/Guayaquil",
    },
    {
      name: "Egypt",
      dial_code: "+20",
      flag: "🇪🇬",
      code: "EG",
      timezone: "Africa/Cairo",
    },
    {
      name: "El Salvador",
      dial_code: "+503",
      flag: "🇸🇻",
      code: "SV",
      timezone: "America/El_Salvador",
    },
    {
      name: "Equatorial Guinea",
      dial_code: "+240",
      flag: "🇬🇶",
      code: "GQ",
      timezone: "Africa/Malabo",
    },
    {
      name: "Eritrea",
      dial_code: "+291",
      flag: "🇪🇷",
      code: "ER",
      timezone: "Africa/Asmara",
    },
    {
      name: "Estonia",
      dial_code: "+372",
      flag: "🇪🇪",
      code: "EE",
      timezone: "Europe/Tallinn",
    },
    {
      name: "Ethiopia",
      dial_code: "+251",
      flag: "🇪🇹",
      code: "ET",
      timezone: "Africa/Addis_Ababa",
    },
    {
      name: "Falkland Islands (Malvinas)",
      dial_code: "+500",
      flag: "🇫🇰",
      code: "FK",
      timezone: "Atlantic/Stanley",
    },
    {
      name: "Faroe Islands",
      dial_code: "+298",
      flag: "🇫🇴",
      code: "FO",
      timezone: "Atlantic/Faroe",
    },
    {
      name: "Fiji",
      dial_code: "+679",
      flag: "🇫🇯",
      code: "FJ",
      timezone: "Pacific/Fiji",
    },
    {
      name: "Finland",
      dial_code: "+358",
      flag: "🇫🇮",
      code: "FI",
      timezone: "Europe/Helsinki",
    },
    {
      name: "France",
      dial_code: "+33",
      flag: "🇫🇷",
      code: "FR",
      timezone: "Europe/Paris",
    },
    {
      name: "French Guiana",
      dial_code: "+594",
      flag: "🇬🇫",
      code: "GF",
      timezone: "America/Cayenne",
    },
    {
      name: "French Polynesia",
      dial_code: "+689",
      flag: "🇵🇫",
      code: "PF",
      timezone: "Pacific/Tahiti",
    },
    {
      name: "Gabon",
      dial_code: "+241",
      flag: "🇬🇦",
      code: "GA",
      timezone: "Africa/Libreville",
    },
    {
      name: "Gambia",
      dial_code: "+220",
      flag: "🇬🇲",
      code: "GM",
      timezone: "Africa/Banjul",
    },
    {
      name: "Georgia",
      dial_code: "+995",
      flag: "🇬🇪",
      code: "GE",
      timezone: "Asia/Tbilisi",
    },
    {
      name: "Germany",
      dial_code: "+49",
      flag: "🇩🇪",
      code: "DE",
      timezone: "Europe/Berlin",
    },
    {
      name: "Ghana",
      dial_code: "+233",
      flag: "🇬🇭",
      code: "GH",
      timezone: "Africa/Accra",
    },
    {
      name: "Gibraltar",
      dial_code: "+350",
      flag: "🇬🇮",
      code: "GI",
      timezone: "Europe/Gibraltar",
    },
    {
      name: "Greece",
      dial_code: "+30",
      flag: "🇬🇷",
      code: "GR",
      timezone: "Europe/Athens",
    },
    {
      name: "Greenland",
      dial_code: "+299",
      flag: "🇬🇱",
      code: "GL",
      timezone: "America/Godthab",
    },
    {
      name: "Grenada",
      dial_code: "+1473",
      flag: "🇬🇩",
      code: "GD",
      timezone: "America/Grenada",
    },
    {
      name: "Guadeloupe",
      dial_code: "+590",
      flag: "🇬🇵",
      code: "GP",
      timezone: "America/Guadeloupe",
    },
    {
      name: "Guam",
      dial_code: "+1671",
      flag: "🇬🇺",
      code: "GU",
      timezone: "Pacific/Guam",
    },
    {
      name: "Guatemala",
      dial_code: "+502",
      flag: "🇬🇹",
      code: "GT",
      timezone: "America/Guatemala",
    },
    {
      name: "Guernsey",
      dial_code: "+44",
      flag: "🇬🇬",
      code: "GG",
      timezone: "Europe/Guernsey",
    },
    {
      name: "Guinea",
      dial_code: "+224",
      flag: "🇬🇳",
      code: "GN",
      timezone: "Africa/Conakry",
    },
    {
      name: "Guinea-Bissau",
      dial_code: "+245",
      flag: "🇬🇼",
      code: "GW",
      timezone: "Africa/Bissau",
    },
    {
      name: "Guyana",
      dial_code: "+595",
      flag: "🇬🇾",
      code: "GY",
      timezone: "America/Guyana",
    },
    {
      name: "Haiti",
      dial_code: "+509",
      flag: "🇭🇹",
      code: "HT",
      timezone: "America/Port-au-Prince",
    },
    {
      name: "Holy See (Vatican City State)",
      dial_code: "+379",
      flag: "🇻🇦",
      code: "VA",
      timezone: "Europe/Vatican",
    },
    {
      name: "Honduras",
      dial_code: "+504",
      flag: "🇭🇳",
      code: "HN",
      timezone: "America/Tegucigalpa",
    },
    {
      name: "Hong Kong",
      dial_code: "+852",
      flag: "🇭🇰",
      code: "HK",
      timezone: "Asia/Hong_Kong",
    },
    {
      name: "Hungary",
      dial_code: "+36",
      flag: "🇭🇺",
      code: "HU",
      timezone: "Europe/Budapest",
    },
    {
      name: "Iceland",
      dial_code: "+354",
      flag: "🇮🇸",
      code: "IS",
      timezone: "Atlantic/Reykjavik",
    },
    {
      name: "India",
      dial_code: "+91",
      flag: "🇮🇳",
      code: "IN",
      timezone: "Asia/Kolkata",
    },
    {
      name: "Indonesia",
      dial_code: "+62",
      flag: "🇮🇩",
      code: "ID",
      timezone: "Asia/Jakarta",
    },
    {
      name: "Iran, Islamic Republic of Persian Gulf",
      dial_code: "+98",
      flag: "🇮🇷",
      code: "IR",
      timezone: "Asia/Tehran",
    },
    {
      name: "Iraq",
      dial_code: "+964",
      flag: "🇮🇷",
      code: "IQ",
      timezone: "Asia/Baghdad",
    },
    {
      name: "Ireland",
      dial_code: "+353",
      flag: "🇮🇪",
      code: "IE",
      timezone: "Europe/Dublin",
    },
    {
      name: "Isle of Man",
      dial_code: "+44",
      flag: "🇮🇲",
      code: "IM",
      timezone: "Europe/Isle_of_Man",
    },
    {
      name: "Israel",
      dial_code: "+972",
      flag: "🇮🇱",
      code: "IL",
      timezone: "Asia/Jerusalem",
    },
    {
      name: "Italy",
      dial_code: "+39",
      flag: "🇮🇹",
      code: "IT",
      timezone: "Europe/Rome",
    },
    {
      name: "Jamaica",
      dial_code: "+1876",
      flag: "🇯🇲",
      code: "JM",
      timezone: "America/Jamaica",
    },
    {
      name: "Japan",
      dial_code: "+81",
      flag: "🇯🇵",
      code: "JP",
      timezone: "Asia/Tokyo",
    },
    {
      name: "Jersey",
      dial_code: "+44",
      flag: "🇯🇪",
      code: "JE",
      timezone: "Europe/Jersey",
    },
    {
      name: "Jordan",
      dial_code: "+962",
      flag: "🇯🇴",
      code: "JO",
      timezone: "Asia/Amman",
    },
    {
      name: "Kazakhstan",
      dial_code: "+77",
      flag: "🇰🇿",
      code: "KZ",
      timezone: "Asia/Almaty",
    },
    {
      name: "Kenya",
      dial_code: "+254",
      flag: "🇰🇪",
      code: "KE",
      timezone: "Africa/Nairobi",
    },
    {
      name: "Kiribati",
      dial_code: "+686",
      flag: "🇰🇮",
      code: "KI",
      timezone: "Pacific/Tarawa",
    },
    {
      name: "Korea, Democratic People's Republic of Korea",
      dial_code: "+850",
      flag: "🇰🇵",
      code: "KP",
      timezone: "Asia/Pyongyang",
    },
    {
      name: "Korea, Republic of South Korea",
      dial_code: "+82",
      flag: "🇰🇷",
      code: "KR",
      timezone: "Asia/Seoul",
    },
    {
      name: "Kuwait",
      dial_code: "+965",
      flag: "🇰🇼",
      code: "KW",
      timezone: "Asia/Kuwait",
    },
    {
      name: "Kyrgyzstan",
      dial_code: "+996",
      flag: "🇰🇬",
      code: "KG",
      timezone: "Asia/Bishkek",
    },
    {
      name: "Laos",
      dial_code: "+856",
      flag: "🇱🇦",
      code: "LA",
      timezone: "Asia/Vientiane",
    },
    {
      name: "Latvia",
      dial_code: "+371",
      flag: "🇱🇻",
      code: "LV",
      timezone: "Europe/Riga",
    },
    {
      name: "Lebanon",
      dial_code: "+961",
      flag: "🇱🇧",
      code: "LB",
      timezone: "Asia/Beirut",
    },
    {
      name: "Lesotho",
      dial_code: "+266",
      flag: "🇱🇸",
      code: "LS",
      timezone: "Africa/Maseru",
    },
    {
      name: "Liberia",
      dial_code: "+231",
      flag: "🇱🇷",
      code: "LR",
      timezone: "Africa/Monrovia",
    },
    {
      name: "Libyan Arab Jamahiriya",
      dial_code: "+218",
      flag: "🇱🇾",
      code: "LY",
      timezone: "Africa/Tripoli",
    },
    {
      name: "Liechtenstein",
      dial_code: "+423",
      flag: "🇱🇮",
      code: "LI",
      timezone: "Europe/Vaduz",
    },
    {
      name: "Lithuania",
      dial_code: "+370",
      flag: "🇱🇹",
      code: "LT",
      timezone: "Europe/Vilnius",
    },
    {
      name: "Luxembourg",
      dial_code: "+352",
      flag: "🇱🇺",
      code: "LU",
      timezone: "Europe/Luxembourg",
    },
    {
      name: "Macao",
      dial_code: "+853",
      flag: "🇲🇴",
      code: "MO",
      timezone: "Asia/Macau",
    },
    {
      name: "Macedonia",
      dial_code: "+389",
      flag: "🇲🇰",
      code: "MK",
      timezone: "Europe/Skopje",
    },
    {
      name: "Madagascar",
      dial_code: "+261",
      flag: "🇲🇬",
      code: "MG",
      timezone: "Indian/Antananarivo",
    },
    {
      name: "Malawi",
      dial_code: "+265",
      flag: "🇲🇼",
      code: "MW",
      timezone: "Africa/Blantyre",
    },
    {
      name: "Malaysia",
      dial_code: "+60",
      flag: "🇲🇾",
      code: "MY",
      timezone: "Asia/Kuala_Lumpur",
    },
    {
      name: "Maldives",
      dial_code: "+960",
      flag: "🇲🇻",
      code: "MV",
      timezone: "Indian/Maldives",
    },
    {
      name: "Mali",
      dial_code: "+223",
      flag: "🇲🇱",
      code: "ML",
      timezone: "Africa/Bamako",
    },
    {
      name: "Malta",
      dial_code: "+356",
      flag: "🇲🇹",
      code: "MT",
      timezone: "Europe/Malta",
    },
    {
      name: "Marshall Islands",
      dial_code: "+692",
      flag: "🇲🇭",
      code: "MH",
      timezone: "Pacific/Majuro",
    },
    {
      name: "Martinique",
      dial_code: "+596",
      flag: "🇲🇶",
      code: "MQ",
      timezone: "America/Martinique",
    },
    {
      name: "Mauritania",
      dial_code: "+222",
      flag: "🇲🇷",
      code: "MR",
      timezone: "Africa/Nouakchott",
    },
    {
      name: "Mauritius",
      dial_code: "+230",
      flag: "🇲🇺",
      code: "MU",
      timezone: "Indian/Mauritius",
    },
    {
      name: "Mayotte",
      dial_code: "+262",
      flag: "🇾🇹",
      code: "YT",
      timezone: "Indian/Mayotte",
    },
    {
      name: "Mexico",
      dial_code: "+52",
      flag: "🇲🇽",
      code: "MX",
      timezone: "America/Mexico_City",
    },
    {
      name: "Micronesia, Federated States of Micronesia",
      dial_code: "+691",
      flag: "🇫🇲",
      code: "FM",
      timezone: "Pacific/Chuuk",
    },
    {
      name: "Moldova",
      dial_code: "+373",
      flag: "🇲🇩",
      code: "MD",
      timezone: "Europe/Chisinau",
    },
    {
      name: "Monaco",
      dial_code: "+377",
      flag: "🇲🇨",
      code: "MC",
      timezone: "Europe/Monaco",
    },
    {
      name: "Mongolia",
      dial_code: "+976",
      flag: "🇲🇳",
      code: "MN",
      timezone: "Asia/Ulaanbaatar",
    },
    {
      name: "Montenegro",
      dial_code: "+382",
      flag: "🇲🇪",
      code: "ME",
      timezone: "Europe/Podgorica",
    },
    {
      name: "Montserrat",
      dial_code: "+1664",
      flag: "🇲🇸",
      code: "MS",
      timezone: "America/Montserrat",
    },
    {
      name: "Morocco",
      dial_code: "+212",
      flag: "🇲🇦",
      code: "MA",
      timezone: "Africa/Casablanca",
    },
    {
      name: "Mozambique",
      dial_code: "+258",
      flag: "🇲🇿",
      code: "MZ",
      timezone: "Africa/Maputo",
    },
    {
      name: "Myanmar",
      dial_code: "+95",
      flag: "🇲🇲",
      code: "MM",
      timezone: "Asia/Yangon",
    },
    {
      name: "Namibia",
      flag: "🇳🇦",
      dial_code: "+264",
      code: "NA",
      timezone: "Africa/Windhoek",
    },
    {
      name: "Nauru",
      dial_code: "+674",
      flag: "🇳🇷",
      code: "NR",
      timezone: "Pacific/Nauru",
    },
    {
      name: "Nepal",
      dial_code: "+977",
      flag: "🇳🇵",
      code: "NP",
      timezone: "Asia/Kathmandu",
    },
    {
      name: "Netherlands",
      dial_code: "+31",
      flag: "🇳🇱",
      code: "NL",
      timezone: "Europe/Amsterdam",
    },
    {
      name: "Netherlands Antilles",
      dial_code: "+599",
      flag: "🇧🇶",
      code: "AN",
      timezone: "America/Curacao",
    },
    {
      name: "New Caledonia",
      dial_code: "+687",
      flag: "🇳🇨",
      code: "NC",
      timezone: "Pacific/Noumea",
    },
    {
      name: "New Zealand",
      dial_code: "+64",
      flag: "🇳🇿",
      code: "NZ",
      timezone: "Pacific/Auckland",
    },
    {
      name: "Nicaragua",
      dial_code: "+505",
      flag: "🇳🇮",
      code: "NI",
      timezone: "America/Managua",
    },
    {
      name: "Niger",
      dial_code: "+227",
      flag: "🇳🇪",
      code: "NE",
      timezone: "Africa/Niamey",
    },
    {
      name: "Nigeria",
      dial_code: "+234",
      flag: "🇳🇬",
      code: "NG",
      timezone: "Africa/Lagos",
    },
    {
      name: "Niue",
      dial_code: "+683",
      flag: "🇳🇺",
      code: "NU",
      timezone: "Pacific/Niue",
    },
    {
      name: "Norfolk Island",
      dial_code: "+672",
      flag: "🇳🇫",
      code: "NF",
      timezone: "Pacific/Norfolk",
    },
    {
      name: "Northern Mariana Islands",
      dial_code: "+1670",
      flag: "🇲🇵",
      code: "MP",
      timezone: "Pacific/Saipan",
    },
    {
      name: "Norway",
      dial_code: "+47",
      flag: "🇳🇴",
      code: "NO",
      timezone: "Europe/Oslo",
    },
    {
      name: "Oman",
      dial_code: "+968",
      flag: "🇴🇲",
      code: "OM",
      timezone: "Asia/Muscat",
    },
    {
      name: "Pakistan",
      dial_code: "+92",
      flag: "🇵🇰",
      code: "PK",
      timezone: "Asia/Karachi",
    },
    {
      name: "Palau",
      dial_code: "+680",
      flag: "🇵🇼",
      code: "PW",
      timezone: "Pacific/Palau",
    },
    {
      name: "Palestinian Territory, Occupied",
      dial_code: "+970",
      flag: "🇵🇸",
      code: "PS",
      timezone: "Asia/Hebron",
    },
    {
      name: "Panama",
      dial_code: "+507",
      flag: "🇵🇦",
      code: "PA",
      timezone: "America/Panama",
    },
    {
      name: "Papua New Guinea",
      dial_code: "+675",
      flag: "🇵🇬",
      code: "PG",
      timezone: "Pacific/Port_Moresby",
    },
    {
      name: "Paraguay",
      dial_code: "+595",
      flag: "🇵🇾",
      code: "PY",
      timezone: "America/Asuncion",
    },
    {
      name: "Peru",
      dial_code: "+51",
      flag: "🇵🇪",
      code: "PE",
      timezone: "America/Lima",
    },
    {
      name: "Philippines",
      dial_code: "+63",
      flag: "🇵🇭",
      code: "PH",
      timezone: "Asia/Manila",
    },
    {
      name: "Pitcairn",
      dial_code: "+872",
      flag: "🇵🇳",
      code: "PN",
      timezone: "Pacific/Pitcairn",
    },
    {
      name: "Poland",
      dial_code: "+48",
      flag: "🇵🇱",
      code: "PL",
      timezone: "Europe/Warsaw",
    },
    {
      name: "Portugal",
      dial_code: "+351",
      flag: "🇵🇹",
      code: "PT",
      timezone: "Europe/Lisbon",
    },
    {
      name: "Puerto Rico",
      dial_code: "+1939",
      flag: "🇵🇷",
      code: "PR",
      timezone: "America/Puerto_Rico",
    },
    {
      name: "Qatar",
      dial_code: "+974",
      flag: "🇶🇦",
      code: "QA",
      timezone: "Asia/Qatar",
    },
    {
      name: "Romania",
      dial_code: "+40",
      flag: "🇷🇴",
      code: "RO",
      timezone: "Europe/Bucharest",
    },
    {
      name: "Russia",
      dial_code: "+7",
      flag: "🇷🇺",
      code: "RU",
      timezone: "Europe/Kaliningrad",
    },
    {
      name: "Rwanda",
      dial_code: "+250",
      flag: "🇷🇼",
      code: "RW",
      timezone: "Africa/Kigali",
    },
    {
      name: "Reunion",
      dial_code: "+262",
      flag: "🇷🇪",
      code: "RE",
      timezone: "Indian/Reunion",
    },
    {
      name: "Saint Barthelemy",
      dial_code: "+590",
      flag: "🇧🇱",
      code: "BL",
      timezone: "America/St_Barthelemy",
    },
    {
      name: "Saint Helena, Ascension and Tristan Da Cunha",
      dial_code: "+290",
      flag: "🇸🇭",
      code: "SH",
      timezone: "Atlantic/St_Helena",
    },
    {
      name: "Saint Kitts and Nevis",
      dial_code: "+1869",
      flag: "🇰🇳",
      code: "KN",
      timezone: "America/St_Kitts",
    },
    {
      name: "Saint Lucia",
      dial_code: "+1758",
      flag: "🇱🇨",
      code: "LC",
      timezone: "America/St_Lucia",
    },
    {
      name: "Saint Martin",
      dial_code: "+590",
      flag: "🇲🇫",
      code: "MF",
      timezone: "America/Marigot",
    },
    {
      name: "Saint Pierre and Miquelon",
      dial_code: "+508",
      flag: "🇵🇲",
      code: "PM",
      timezone: "America/Miquelon",
    },
    {
      name: "Saint Vincent and the Grenadines",
      dial_code: "+1784",
      flag: "🇻🇨",
      code: "VC",
      timezone: "America/St_Vincent",
    },
    {
      name: "Samoa",
      dial_code: "+685",
      flag: "🇼🇸",
      code: "WS",
      timezone: "Pacific/Apia",
    },
    {
      name: "San Marino",
      dial_code: "+378",
      flag: "🇸🇲",
      code: "SM",
      timezone: "Europe/San_Marino",
    },
    {
      name: "Sao Tome and Principe",
      dial_code: "+239",
      flag: "🇸🇹",
      code: "ST",
      timezone: "Africa/Sao_Tome",
    },
    {
      name: "Saudi Arabia",
      dial_code: "+966",
      flag: "🇸🇦",
      code: "SA",
      timezone: "Asia/Riyadh",
    },
    {
      name: "Senegal",
      dial_code: "+221",
      flag: "🇸🇳",
      code: "SN",
      timezone: "Africa/Dakar",
    },
    {
      name: "Serbia",
      dial_code: "+381",
      flag: "🇷🇸",
      code: "RS",
      timezone: "Europe/Belgrade",
    },
    {
      name: "Seychelles",
      dial_code: "+248",
      flag: "🇸🇨",
      code: "SC",
      timezone: "Indian/Mahe",
    },
    {
      name: "Sierra Leone",
      dial_code: "+232",
      flag: "🇸🇱",
      code: "SL",
      timezone: "Africa/Freetown",
    },
    {
      name: "Singapore",
      dial_code: "+65",
      flag: "🇸🇬",
      code: "SG",
      timezone: "Asia/Singapore",
    },
    {
      name: "Slovakia",
      dial_code: "+421",
      flag: "🇸🇰",
      code: "SK",
      timezone: "Europe/Bratislava",
    },
    {
      name: "Slovenia",
      dial_code: "+386",
      flag: "🇸🇮",
      code: "SI",
      timezone: "Europe/Ljubljana",
    },
    {
      name: "Solomon Islands",
      dial_code: "+677",
      flag: "🇸🇧",
      code: "SB",
      timezone: "Pacific/Guadalcanal",
    },
    {
      name: "Somalia",
      dial_code: "+252",
      flag: "🇸🇴",
      code: "SO",
      timezone: "Africa/Mogadishu",
    },
    {
      name: "South Africa",
      dial_code: "+27",
      flag: "🇿🇦",
      code: "ZA",
      timezone: "Africa/Johannesburg",
    },
    {
      name: "South Sudan",
      dial_code: "+211",
      flag: "🇸🇸",
      code: "SS",
      timezone: "Africa/Juba",
    },
    {
      name: "South Georgia and the South Sandwich Islands",
      dial_code: "+500",
      flag: "🇬🇸",
      code: "GS",
      timezone: "Atlantic/South_Georgia",
    },
    {
      name: "Spain",
      dial_code: "+34",
      flag: "🇪🇸",
      code: "ES",
      timezone: "Europe/Madrid",
    },
    {
      name: "Sri Lanka",
      dial_code: "+94",
      flag: "🇱🇰",
      code: "LK",
      timezone: "Asia/Colombo",
    },
    {
      name: "Sudan",
      dial_code: "+249",
      flag: "🇸🇩",
      code: "SD",
      timezone: "Africa/Khartoum",
    },
    {
      name: "Suriname",
      dial_code: "+597",
      flag: "🇸🇷",
      code: "SR",
      timezone: "America/Paramaribo",
    },
    {
      name: "Svalbard and Jan Mayen",
      dial_code: "+47",
      flag: "🇸🇯",
      code: "SJ",
      timezone: "Arctic/Longyearbyen",
    },
    {
      name: "Swaziland",
      dial_code: "+268",
      flag: "🇸🇿",
      code: "SZ",
      timezone: "Africa/Mbabane",
    },
    {
      name: "Sweden",
      dial_code: "+46",
      flag: "🇸🇪",
      code: "SE",
      timezone: "Europe/Stockholm",
    },
    {
      name: "Switzerland",
      dial_code: "+41",
      flag: "🇨🇭",
      code: "CH",
      timezone: "Europe/Zurich",
    },
    {
      name: "Syrian Arab Republic",
      dial_code: "+963",
      flag: "🇸🇾",
      code: "SY",
      timezone: "Asia/Damascus",
    },
    {
      name: "Taiwan",
      dial_code: "+886",
      flag: "🇹🇼",
      code: "TW",
      timezone: "Asia/Taipei",
    },
    {
      name: "Tajikistan",
      dial_code: "+992",
      flag: "🇹🇯",
      code: "TJ",
      timezone: "Asia/Dushanbe",
    },
    {
      name: "Tanzania, United Republic of Tanzania",
      dial_code: "+255",
      flag: "🇹🇿",
      code: "TZ",
      timezone: "Africa/Dar_es_Salaam",
    },
    {
      name: "Thailand",
      dial_code: "+66",
      flag: "🇹🇭",
      code: "TH",
      timezone: "Asia/Bangkok",
    },
    {
      name: "Timor-Leste",
      dial_code: "+670",
      flag: "🇹🇱",
      code: "TL",
      timezone: "Asia/Dili",
    },
    {
      name: "Togo",
      dial_code: "+228",
      flag: "🇹🇬",
      code: "TG",
      timezone: "Africa/Lome",
    },
    {
      name: "Tokelau",
      dial_code: "+690",
      flag: "🇹🇰",
      code: "TK",
      timezone: "Pacific/Fakaofo",
    },
    {
      name: "Tonga",
      dial_code: "+676",
      flag: "🇹🇴",
      code: "TO",
      timezone: "Pacific/Tongatapu",
    },
    {
      name: "Trinidad and Tobago",
      dial_code: "+1868",
      flag: "🇹🇹",
      code: "TT",
      timezone: "America/Port_of_Spain",
    },
    {
      name: "Tunisia",
      dial_code: "+216",
      flag: "🇹🇳",
      code: "TN",
      timezone: "Africa/Tunis",
    },
    {
      name: "Turkey",
      dial_code: "+90",
      flag: "🇹🇷",
      code: "TR",
      timezone: "Europe/Istanbul",
    },
    {
      name: "Turkmenistan",
      dial_code: "+993",
      flag: "🇹🇲",
      code: "TM",
      timezone: "Asia/Ashgabat",
    },
    {
      name: "Turks and Caicos Islands",
      dial_code: "+1649",
      flag: "🇹🇨",
      code: "TC",
      timezone: "America/Grand_Turk",
    },
    {
      name: "Tuvalu",
      dial_code: "+688",
      flag: "🇹🇻",
      code: "TV",
      timezone: "Pacific/Funafuti",
    },
    {
      name: "Uganda",
      dial_code: "+256",
      flag: "🇺🇬",
      code: "UG",
      timezone: "Africa/Kampala",
    },
    {
      name: "Ukraine",
      dial_code: "+380",
      flag: "🇺🇦",
      code: "UA",
      timezone: "Europe/Kiev",
    },
    {
      name: "United Arab Emirates",
      dial_code: "+971",
      flag: "🇦🇪",
      code: "AE",
      timezone: "Asia/Dubai",
    },
    {
      name: "United Kingdom",
      dial_code: "+44",
      flag: "🇬🇧",
      code: "GB",
      timezone: "Europe/London",
    },
    {
      name: "United States",
      dial_code: "+1",
      flag: "🇺🇸",
      code: "US",
      timezone: "America/New_York",
    },
    {
      name: "Uruguay",
      dial_code: "+598",
      flag: "🇺🇾",
      code: "UY",
      timezone: "America/Montevideo",
    },
    {
      name: "Uzbekistan",
      dial_code: "+998",
      flag: "🇺🇿",
      code: "UZ",
      timezone: "Asia/Samarkand",
    },
    {
      name: "Vanuatu",
      dial_code: "+678",
      flag: "🇻🇺",
      code: "VU",
      timezone: "Pacific/Efate",
    },
    {
      name: "Venezuela, Bolivarian Republic of Venezuela",
      dial_code: "+58",
      flag: "🇻🇪",
      code: "VE",
      timezone: "America/Caracas",
    },
    {
      name: "Vietnam",
      dial_code: "+84",
      flag: "🇻🇳",
      code: "VN",
      timezone: "Asia/Ho_Chi_Minh",
    },
    {
      name: "Virgin Islands, British",
      dial_code: "+1284",
      flag: "🇻🇬",
      code: "VG",
      timezone: "America/Tortola",
    },
    {
      name: "Virgin Islands, U.S.",
      dial_code: "+1340",
      flag: "🇻🇮",
      code: "VI",
      timezone: "America/St_Thomas",
    },
    {
      name: "Wallis and Futuna",
      dial_code: "+681",
      flag: "🇼🇫",
      code: "WF",
      timezone: "Pacific/Wallis",
    },
    {
      name: "Yemen",
      dial_code: "+967",
      flag: "🇾🇪",
      code: "YE",
      timezone: "Asia/Aden",
    },
    {
      name: "Zambia",
      dial_code: "+260",
      flag: "🇿🇲",
      code: "ZM",
      timezone: "Africa/Lusaka",
    },
    {
      name: "Zimbabwe",
      dial_code: "+263",
      flag: "🇿🇼",
      code: "ZW",
      timezone: "Africa/Harare",
    },
  ];